export default __webpack_public_path__ + "static/media/studentAnalysis.fecccf62.png";